export const ChipsItems = [
  { label: "All Types", id: "1" },
  { label: "Subscription", id: "2" },
  { label: "Single Order", id: "3" },
];

export const cardsItems = [
  {
    img: "https://picsum.photos/200",
    label: "Personal subscription",
    heading: "Baked Fish Fillets with Cheese Sauce",
    address: "Chef Juna Food, 4474 Bridge",
    date: "12 Oct -12 Nov 2021",
    chipColor: "#7B49E5",
  },
  {
    img: "https://picsum.photos/200",
    label: "Personal subscription",
    heading: "Baked Fish Fillets with Cheese Sauce",
    address: "Chef Juna Food, 4474 Bridge",
    date: "12 Oct -12 Nov 2021",
    chipColor: "#FF9933",
  },
  {
    img: "https://picsum.photos/200",
    label: "Personal subscription",
    heading: "Baked Fish Fillets with Cheese Sauce",
    address: "Chef Juna Food, 4474 Bridge",
    date: "12 Oct -12 Nov 2021",
    chipColor: "#FF8D85",
  },
];
